﻿let _ = require('lodash');
let Q = require('q');

module.exports = DonationLevels;

function DonationLevels(customOptions) {

    let defaultOptions = {
        formId: null,
        v: '1.0',
        levelsContainer: null,
        designationsList: null,
        designationsContainer: null,
        luminateConfig: null,
        customAmountPlaceholder: 'My Preferred Amount',
        selectFirstOption: true,
        selectedLevelId: null,
        selectedAmount: null,
        chosenDesignationId: null,
        designationName: null,
        onAmountChange: () => { },
        onDesignationChange: () => { }
    }

    let options = $.extend({}, defaultOptions, customOptions);
    if (options.selectedAmount) {
        options.selectedAmount = this.parseAmount(options.selectedAmount);
    }

    _.assign(this, options);
    this.onAmountChange(this.selectedAmount);    
}

DonationLevels.prototype = {
    getFormDonationLevels() {
        return Q($.ajax({
            url: `${luminateClientApiConfig.BaseUrl}CRDonationAPI`,
            type: 'POST',
            data: _.assign({
                method: 'getDonationFormInfo',
                form_id: this.formId,
                v: luminateClientApiConfig.Version,
                response_format: 'json'
            }, this.luminateConfig),
            xhrFields: { withCredentials: true },
        }))
        .then(JSON.parse)
        .then(response => response.getDonationFormInfoResponse);
    },

    initialize() {
        return this.getFormDonationLevels()
            .then(donationFormInfo => this.setDesignations(donationFormInfo))
            .then(levels => this.setDonationLevels(levels))
            .then(levels => this.renderDonationLevels(levels))
    },

    setDesignations(donationFormInfo){
        var thisObject = this;
        if (donationFormInfo.supportsDesignation){
            $.ajax({
                url: jnfroutesconfg.Designations + "?id=" + this.formId,
                type: 'GET',
                success: function(result, args){
                    thisObject.renderDesignations(result);
                },
                error: function(error){
                    console.log(error);
                }
            });
        }
        return donationFormInfo.donationLevels.donationLevel;
    },

    setDonationLevels(levels) {
        let levelsList = _.isArray(levels) ? levels : [levels];

        this.donationLevels = _.keyBy(levelsList, 'level_id');
        
        let predefined = _.filter(levelsList, level => level.userSpecified == 'false');
        let sortedPredefined = _.orderBy(predefined, level => parseFloat(level.amount.decimal), 'desc');
        let userSpecified = _.filter(levelsList, level => level.userSpecified == 'true');

        if (!this.selectedLevelId && this.selectFirstOption) {
            let firstLevel = _.head(sortedPredefined);
            this.selectedLevelId = firstLevel ? firstLevel.level_id : null;
            this.selectedAmount = firstLevel ? firstLevel.amount.decimal : null;
        }

        return [sortedPredefined, userSpecified];
    },

    renderDesignations(designations) {
        var thisObject = this;
        var listOfDesignations = _.map(designations, designation =>
            `<li class="list-element" data-id='${designation.id}'>${designation.name}</li>`
        );
        if(this.designationsContainer !== null){
            this.designationsContainer.css('display', 'block');
            this.designationsList.append(listOfDesignations);
        }
        let designationsElement = $('.designations-list .designations li.list-element');
        designationsElement.on('click', function(){
            let clickedDesignation = $(this).attr('data-id');            
            designationsElement.removeClass('selected');
            
            if(clickedDesignation === thisObject.chosenDesignationId) {                
                thisObject.chosenDesignationId = undefined;
                thisObject.designationName = undefined;
                thisObject.onDesignationChange(undefined);
            } else {
                $(this).addClass('selected');
                thisObject.chosenDesignationId = clickedDesignation;
                thisObject.designationName = $(this).html();
                thisObject.onDesignationChange(thisObject.designationName);
            }
        });
    },

    renderDonationLevels([predefined, userSpecified]) {

        _.each(predefined, level => this.renderPredefinedLevel(level));
        _.each(userSpecified, level => this.renderUserSpecifiedLevel(level));
    },


    renderPredefinedLevel(level) {
        let amount = _.toNumber(level.amount.decimal);
        let formattedAmount = _.isInteger(amount) ? amount.toFixed(0) : amount.toFixed(2);

        let button = $(`<button class='level-element' data-level-id='${level.level_id}' data-amount='${level.amount.decimal}'>$${formattedAmount}</button>`);
        button.click(event => {
            event.preventDefault();
            this.onElementSelected(button);
        });

        if(level.level_id == this.selectedLevelId) {
            this.onElementSelected(button);
        }

        let levelWrapper = $(`<li class='donation-level predefined'/>`);
        levelWrapper.append(button);
        this.levelsContainer.append(levelWrapper);
    },

    renderUserSpecifiedLevel(level) {
        let input = $(`<input class='level-element' placeholder='${this.customAmountPlaceholder}' data-level-id='${level.level_id}' data-amount='' type='text'>`);
        input.keyup(event => this.onElementSelected(input));

        if(level.level_id == this.selectedLevelId && this.selectedAmount) {
            input.val(this.selectedAmount);
            input.addClass('active');
        }

        let levelWrapper = $(`<li class='donation-level custom'/>`);
        levelWrapper.append(input);
        this.levelsContainer.append(levelWrapper);
    },

    onElementSelected(element) {        
        let levelId = element.data('level-id');
        let amount = element.data('amount').toString() || element.val();

        if(levelId && amount) {

            this.selectedLevelId = levelId;
            this.selectedAmount = this.parseAmount(amount);
            this.selectElement(element);
            this.onAmountChange(this.selectedAmount);
        } else {
            this.selectedLevelId = null;
            this.selectedAmount = null;
            this.selectElement();
        }
    },

    selectElement(element) {
        this.levelsContainer.find('.level-element')
            .not(element)
            .removeClass('active')
            .val('');
        
        if(element) {
            element.addClass('active');
        }
    },

    parseAmount(amount) {
        return amount.replace(/[,\s\$]/g, '');
    },

    isAmountValid(amount) {
        return amount && !isNaN(amount);
    },

    isSelectedLevelPredefined() {
        if (!this.selectedLevelId) return;

        let selectedLevel = this.donationLevels[this.selectedLevelId];
        return selectedLevel.userSpecified !== 'true'; 
    },

    validate() {
        let result = this.getValidationResult(true);

        if (!this.selectedLevelId) {
            result = this.getValidationResult(false, 'Please select donation level.');

        } else if (!this.selectedAmount || !this.isAmountValid(this.selectedAmount)) {
            result = this.getValidationResult(false, 'Please enter valid donation amount.');

        }

        return result;
    },

    getValidationResult(success, message) {
        return {
            valid: success,
            message: message
        };
    },

    getDonateRequestData() {
        //HACK sending all donation as custom donation amount so that 
        // when user selects donation level and logs in, the amount doesn't change
        let selectedLevel = this.donationLevels[this.selectedLevelId];
        
        let userSpecifiedLevel = selectedLevel.userSpecified == 'false' ? 
            _.find(this.donationLevels, level => level.userSpecified == 'true') : selectedLevel;
        
        return {
            'level_id': userSpecifiedLevel.level_id || this.selectedLevelId,
            'other_amount': this.selectedAmount,
            'designated.1.id': this.chosenDesignationId,
            'designated.1.amount': this.chosenDesignationId ?  this.selectedAmount : null,
            'designation.name': this.designationName
        }
    }
}